export default __webpack_public_path__ + "static/media/gear-blue.c8e7442c.png";